import { useAtom } from "jotai";
import { discountCodeAtom } from "../atoms";

const defaultValue = { isApplied: false, code: "" };

const useDiscountCodeHook = () => {
  const [discountCode, setDiscountCode] = useAtom(discountCodeAtom);
  const resetDiscountCode = () => setDiscountCode(defaultValue);

  return { resetDiscountCode, discountCode, setDiscountCode };
};

export default useDiscountCodeHook;
